module.exports = __webpack_public_path__ + "media/images/background-8995f173f64f37e34bb2b1ea01253fea.jpg";